import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { HeaderBlockContainer, HeaderBlockTitle, Title, Subtitle } from './styles';

interface HeaderBlockProps {
	title: string;
	subtitle?: string;
}

const HeaderBlock = (props: HeaderBlockProps) => {
	const { title, subtitle } = props;

	return (
		<HeaderBlockContainer>
			<HeaderBlockTitle>
				<Title><Translate value={title} /></Title>
				{subtitle &&
					<Subtitle>{subtitle}</Subtitle>
				}
			</HeaderBlockTitle>
		</HeaderBlockContainer>
	);
};

export default HeaderBlock;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/HeaderBlock/index.tsx